'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMvAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 7.6592e-06C9.33333 -7.21748e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V7.6592e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 7.6592e-06L28 0V20H0V7.6592e-06Z", fill: "#F32249" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4 4.66667C4 4.29848 4.29848 4 4.66667 4H23.3333C23.7015 4 24 4.29848 24 4.66667V15.3333C24 15.7015 23.7015 16 23.3333 16H4.66667C4.29848 16 4 15.7015 4 15.3333V4.66667Z",
          fill: "#15A04F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.3333 14.5593C16.0112 14.6296 15.6766 14.6667 15.3333 14.6667C12.756 14.6667 10.6667 12.5773 10.6667 10C10.6667 7.42267 12.756 5.33333 15.3333 5.33333C15.6766 5.33333 16.0112 5.37039 16.3333 5.44073C14.2365 5.89851 12.6667 7.76592 12.6667 10C12.6667 12.2341 14.2365 14.1015 16.3333 14.5593Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagMvAsset = forwardRef(FlagMvAsset);

export { VpFlagMvAsset as default };
